/*
This page calls LoginModel component (which has login page, signup page when user sign's up they are taken to otp page where they have to enter a 
6 digit otp which they recieve in the mail which was entered during the signup process).
*/

import LoginModel from '../components/LoginSignup/LoginModel'

const LoginPage = () =>{
    return (
        <LoginModel/>
    );
}

export default LoginPage;